import { CanMatchFn, Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { UserRole } from '../auth/models/user-roles';
import { inject } from '@angular/core';
import { AuthService } from '../auth/services/auth.service';

const canMatchRoles = (roles: UserRole[]): CanMatchFn => () => {
  const auth = inject(AuthService);
  return roles.some(role => auth.userHasRoleAndRoleIsEnabled(role));
};
const metricsUserRoles = [
  UserRole.TenantAdmin,
  UserRole.SuperUser
]

export const systemMetricsRoutes: Routes = [
  {
    path: 'metrics',
    title: 'System Metrics',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import('./pages/system-metrics-page.component').then(
        (m) => m.SystemMetricsPageComponent,
      ),
  },
  {
    path: 'metrics/lockers/health',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import('./battery-health/pages/battery-health-page.component').then(
        (m) => m.BatteryHealthPageComponent,
      ),
  },
  {
    path: 'metrics/lockers/smart',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import('./locker-status/pages/smart-locker-status-page.component').then(
        (m) => m.SmartLockerStatusPage,
      ),
  },
  {
    path: 'metrics/lockers/non-smart',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import(
        './locker-status/pages/non-smart-locker-status-page.component'
      ).then((m) => m.NonSmartLockerStatusPage),
  },
  {
    path: 'metrics/lockers/faults',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import(
        './non-smart-faults/pages/non-smart-locker-fault-page.component'
      ).then((m) => m.NonSmartLockerFaultPageComponent),
  },
  {
    path: 'metrics/installers',
    canLoad: [AutoLoginPartialRoutesGuard],
    canMatch: [canMatchRoles(metricsUserRoles)],
    loadComponent: () =>
      import(
        './lock-installer/lock-installer-report.component'
      ).then((m) => m.LockInstallerReportComponent),
  },
];
